import React, {useEffect, useState} from "react";
import LayoutNew from "../components/shared/LayoutNew";
import { Form, Button, InputGroup, ButtonGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import giftbg from "../assets/images/gift_bg.webp";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
const ReceivingCenter = () => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);
  const {
    formState: { errors },
  } = useForm({});

  const navigate = useNavigate();

  return (
    <LayoutNew>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xlinkHref="http://www.w3.org/1999/xlink"
        style={{ position: `absolute`, width: `0`, height: `0` }}
      >
        <defs>
          <symbol
            xlinkHref="http://www.w3.org/1999/xlink"
            viewBox="0 0 44 44"
            id="left"
          >
            <title>Operation Icons Copy 4</title>
            <defs>
              <path id="left_a" d="M-129-845h24v24h-24z"></path>
            </defs>
            <clipPath id="left_b">
              <use xlinkHref="#left_a" overflow="visible"></use>
            </clipPath>
            <g clipPath="url(#left_b)">
              <defs>
                <path id="left_c" d="M-903-949H947V996H-903z"></path>
              </defs>
              <clipPath id="left_d">
                <use xlinkHref="#left_c" overflow="visible"></use>
              </clipPath>
            </g>
            <path d="M16.247 21.399L28.48 9.166l2.121 2.121-10.118 10.119 10.118 10.118-2.121 2.121-12.233-12.233.007-.006z"></path>
          </symbol>
        </defs>
      </svg>
      <div id="mc-animate-container" class="v-base v-detail-base">
        <div>
          <div class="mc-header-wrap">
            <div
              id="mc-header"
              class="mc-navbar-blue mc-receivingCenter mc-default-header am-navbar am-navbar-light"
            >
              <div class="am-navbar-left" role="button">
                <span class="am-navbar-left-content">
                  <span class="return_icon" onClick={() => navigate(-1)}>
                    <svg class="am-icon am-icon-left am-icon-lg">
                      <use xlinkHref="#left"></use>
                    </svg>
                  </span>
                </span>
              </div>
              <div class="am-navbar-title">Bonus</div>
              <div class="am-navbar-right">
                <div class="to-record">
                  <a href="#">
                    <span class="more-icon claim am-navbar-title"></span>
                  </a>
                </div>
              </div>
            </div>
            <div class="am-whitespace am-whitespace-sm mc-whitespace"></div>
          </div>
          <div class="mall-home-top">
            <div class="mall-header">
              <div class="profile-icon">
                <img
                  src="https://images.6492394993.com//TCG_PROD_IMAGES/B2C/01_PROFILE/PROFILE/0.png"
                  alt=""
                />
              </div>
            </div>
            <div class="mall-number-info">
              <p class="mall-user-name">
                <span class="name-text">{user?.user?.username}</span>
              </p>
              <p class="mall-user-amount number-mc">
                ৳ {Number(userCoins?.balance).toFixed(2) || 0}
              </p>
            </div>
          </div>
          <div class="not_activity">
            <h2>No promotion available yet</h2>
          </div>
        </div>
      </div>
    </LayoutNew>
  );
};

export default ReceivingCenter;
